<template>
  <Modal modalId="premium-enrollment-before-you-upgrade-modal" size="modal-md">
    <ModalHeader
      :title="$t('xBeforeYouUpgrade')"
      icon="far fa-circle-dollar"
      :style="{ padding: '10px 10px 10px 10px' }"
    >
      <div class="cols-auto">
        <button
          type="button"
          class="btn btn-icon-button btn-icon-button--gray"
          @click="closeModal('premium-enrollment-before-you-upgrade-modal')"
        >
          <i class="fas fa-times" />
        </button>
      </div>
    </ModalHeader>
    <ModalBody>
      <div class="row">
        <div class="col">
          {{ $t('xToUpgradeToPremiumAllProductsMustBeIncludedInYourPlan') }}
        </div>
      </div>
      <div class="col-0 mt-1">
        <li v-for="(apparatus, index) in apparatusesIncludedInUpgrade" :key="index" class="ml-2">
          <span>{{ apparatus.apparatusName }}</span>
        </li>
      </div>
      <div class="row mt-4">
        <div class="col">
          {{ $t('xIfYouDontWantCertainProducts') }}
        </div>
      </div>
    </ModalBody>
    <ModalFooter>
      <button
        type="button"
        class="btn btn-outline-warning"
        style="width: 47%;"
        @click="closeModal('premium-enrollment-before-you-upgrade-modal')"
        data-test-hook="cancel-btn-confirm-delete-modal"
      >
        {{ $t('xCancel') }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        style="width: 47%;"
        @click="continueToUpgrade()"
        data-test-hook="continue-to-upgrade-subscription"
      >
        {{ $t('xContinue') }}
      </button>
    </ModalFooter>
  </Modal>
</template>

<script>
export default {
  props: ['apparatusesIncludedInUpgrade'],
  data() {
    return {}
  },
  methods: {
    continueToUpgrade() {
      this.$appInsights.trackEvent({
        name: 'click-continue-to-upgrade-subscription-modal',
        properties: {}
      })

      this.closeModal('premium-enrollment-before-you-upgrade-modal')
      this.$emit('openSubscriptionModal')
    }
  }
}
</script>
